import DOMPurify from 'dompurify';
import React, { FC } from 'react';

const SafeHtmlRenderer: FC<{ content?: string; className?: string }> = ({ content, className }) => (
  <div className={className} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content || '') }} />
);
export default SafeHtmlRenderer;
